import React from 'react'
import Maintenance from '~/components/Maintenance'
import PublicLayout from '~/components/PublicLayout'

export default () => {
  return (
    <PublicLayout>
      <Maintenance />
    </PublicLayout>
  )
}
